import React from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Education from './components/Education';
import Work from './components/Work';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Hero />
      <Education />
      <Work />
      <Skills />
      <Projects />
      <Contact />
    </div>
  );
}

export default App;
